<template>
  <div class="m-publish">
    <van-nav-bar
      title="发布文章"
      left-arrow
      @click-left="$router.back()"
      fixed
      placeholder
    />

    <div class="m-publish__body">
      <!-- 频道选择 -->
      <div class="m-publish__section">
        <div class="m-publish__label">选择频道</div>
        <div class="m-publish__channel-list">
          <div
            v-for="channel in channelList"
            :key="channel.id"
            class="m-publish__channel-tag"
            :class="{ 'm-publish__channel-tag--selected': form.categoryIds.includes(channel.id) }"
            @click="toggleChannel(channel.id)"
          >
            {{ channel.name }}
          </div>
        </div>
      </div>

      <van-divider :hairline="false" class="m-publish__divider" />

      <!-- 标题 -->
      <div class="m-publish__field">
        <van-field
          v-model="form.title"
          placeholder="请输入文章标题"
          maxlength="100"
          class="m-publish__title-input"
          :border="false"
        />
        <van-button
          plain
          type="info"
          size="small"
          class="m-publish__check-btn"
          @click="checkTitleDuplicate"
        >检测重复</van-button>
      </div>

      <!-- 副标题 -->
      <van-field
        v-model="form.subtitle"
        placeholder="副标题（可选）"
        maxlength="100"
        class="m-publish__subtitle-input"
        :border="false"
      />

      <!-- 摘要 -->
      <div class="m-publish__summary">
        <van-field
          v-model="form.summary"
          type="textarea"
          placeholder="请输入摘要内容"
          maxlength="234"
          rows="3"
          autosize
          :border="false"
          class="m-publish__summary-input"
        />
        <div class="m-publish__summary-count">还可输入 {{ summaryRemaining }} 字</div>
      </div>

      <!-- 数据来源 -->
      <div class="m-publish__section">
        <div class="m-publish__label">数据来源</div>
        <div class="m-publish__radio-group">
          <label class="m-publish__radio-item">
            <input type="radio" name="source" value="原创" v-model="form.source" @change="handleSourceChange" />
            <span>原创</span>
          </label>
          <label class="m-publish__radio-item">
            <input type="radio" name="source" value="转载" v-model="form.source" @change="handleSourceChange" />
            <span>转载</span>
          </label>
        </div>
        <div v-if="form.source === '转载'" class="m-publish__original-source">
          <van-field
            v-model="form.originalSource"
            placeholder="请输入转载来源"
            :border="false"
          />
        </div>
      </div>

      <!-- 正文 -->
      <div class="m-publish__content">
        <RichEditor
          v-model="form.content"
          placeholder="在这里开始写作..."
        />
      </div>
    </div>

    <!-- 底部提交 -->
    <div class="m-publish__footer">
      <van-button
        type="primary"
        block
        round
        :disabled="!canSubmit"
        :loading="submitting"
        @click="handleSubmit"
      >提交审核</van-button>
      <div v-if="!canSubmit" class="m-publish__tip">
        {{ userType === 'company' ? '完成企业认证后可发布文章' : '完成实名认证后可发布文章' }}
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import mobileViewport from './mixins/viewport'
import RichEditor from './components/RichEditor.vue'
import request from '../../api/request'
import {
  getNewsContent,
  checkCompanyTitle,
  checkMemberTitle,
  submitCompanyAudit,
  submitMemberAudit
} from '../../api/news'

export default {
  mixins: [mobileViewport],
  name: 'MobilePublishArticle',
  components: {
    RichEditor
  },
  data() {
    return {
      userType: localStorage.getItem('userType') || 'personal',
      authStatus: 0,
      editId: null,
      submitting: false,
      channelList: [],     // 频道列表
      userName: '',        // 用户昵称
      form: {
        title: '',
        subtitle: '',
        summary: '',
        content: '',
        categoryIds: [],   // 频道 ID 数组
        source: '',        // 数据来源：原创/转载
        originalSource: '' // 转载来源
      }
    }
  },
  computed: {
    summaryRemaining() {
      return 400 - (this.form.summary ? this.form.summary.length : 0)
    },
    canSubmit() {
      // 需要认证且
      return this.authStatus === 2 
    }
  },
  created() {
    this.authStatus = parseInt(localStorage.getItem('authStatus') || '0', 10)
    this.editId = this.$route.query.id || null
    // 获取用户昵称
    this.loadUserInfo()
    if (this.editId) {
      this.loadArticleDetail()
    }
  },
  mounted() {
    // 在 DOM 渲染后加载频道列表
    this.loadChannelList()
  },
  methods: {
    async loadChannelList() {
      try {
        // 调用接口:/api/category/getList?type=1(个人) 或 type=2(企业)
        const type = this.userType === 'company' ? 2 : 1
        const res = await request.get('/api/category/getList?type='+type)
            
        // 从返回数据中提取列表
       
        const list = res.data ||  []
            
        this.channelList = Array.isArray(list) ? list : []
            
        console.log(`✅ [${type === 2 ? '企业' : '个人'}] 频道列表加载成功 - ${this.channelList.length}个`)
      } catch (err) {
        console.error(`❌ 获取${this.userType === 'company' ? '企业' : '个人'}频道列表失败:`, err)
        this.channelList = []
      }
    },
    loadUserInfo() {
      try {
        const userInfoStr = localStorage.getItem('userInfo')
        const userInfo = JSON.parse(userInfoStr || '{}')
        this.userName = userInfo.nickname || userInfo.lastName || ''
      } catch (err) {
        console.error('获取用户昵称失败:', err)
      }
    },
    toggleChannel(channelId) {
      const index = this.form.categoryIds.indexOf(channelId)
      if (index > -1) {
        // 取消选择
        this.form.categoryIds.splice(index, 1)
      } else {
        // 选择
        this.form.categoryIds.push(channelId)
      }
    },
    handleSourceChange() {
      // 当切换数据来源时处理后续逻辑
      if (this.form.source === '原创') {
        this.form.originalSource = ''
      }
    },
    getSourceString() {
      if (!this.form.source) return ''
      if (this.form.source === '原创') {
        return `${this.userName}|原创`
      } else if (this.form.source === '转载') {
        // 如果是转载，返回"输入内容 | 转载"
        return `${this.form.originalSource || ''}|转载`
      }
      return ''
    },
    async loadArticleDetail() {
      try {
        const res = await getNewsContent({ id: this.editId })
        const data = res.data || {}
        this.form.title = data.title || ''
        this.form.subtitle = data.subtitle || ''
        this.form.summary = data.summary || ''
        this.form.content = data.content || ''
        // 加载频道和来源数据
        await this.loadChannelList()
        this.loadUserInfo()
        // 加载已有的频道 ID（假设后端返回 categoryId 或 categoryIds）
        const categoryIds = data.categoryIds || data.categoryId || []
        if (Array.isArray(categoryIds)) {
          this.form.categoryIds = categoryIds
        } else if (categoryIds) {
          this.form.categoryIds = [categoryIds]
        }
        // 加载数据来源
        const source = data.source || ''
        if (source) {
          if (source.includes('|原创')) {
            this.form.source = '原创'
          } else if (source.includes('|转载')) {
            this.form.source = '转载'
            // 提取转载来源
            const parts = source.split('|')
            if (parts.length >= 2) {
              this.form.originalSource = parts.slice(0, -1).join('|')
            }
          }
        }
      } catch (err) {
        Toast(err.message || '获取文章详情失败')
      }
    },
    async checkTitleDuplicate() {
      const title = this.form.title.trim()
      if (!title) {
        Toast('请输入文章标题')
        return
      }
      const checkTitle = this.userType === 'company' ? checkCompanyTitle : checkMemberTitle
      try {
        const res = await checkTitle({ title, id: this.editId })
        const isDuplicate = res.data === true || res.data === 'true' || res.data === 1
        if (isDuplicate) {
          Toast('该标题已存在')
        } else {
          Toast('该标题可用')
        }
      } catch (err) {
        Toast(err.message || '标题检测失败')
      }
    },
    async handleSubmit() {
      const title = this.form.title.trim()
      const summary = this.form.summary.trim()
      const content = this.form.content.trim()
      if (!title) {
        Toast('请输入文章标题')
        return
      }
      if (!summary) {
        Toast('请输入摘要')
        return
      }
      if (!content) {
        Toast('请输入文章内容')
        return
      }
      if (!this.canSubmit) {
        Toast(this.userType === 'company' ? '没有进行企业认证无法发布文章' : '没有进行实名认证无法发布文章')
        return
      }
      // 检测标题是否重复
      const checkTitle = this.userType === 'company' ? checkCompanyTitle : checkMemberTitle
      try {
        const checkRes = await checkTitle({ title, id: this.editId })
        const isDuplicate = checkRes.data === true || checkRes.data === 'true' || checkRes.data === 1
        if (isDuplicate) {
          Toast('该标题已存在，请修改标题')
          return
        }
      } catch (err) {
        Toast(err.message || '标题检测失败')
        return
      }
      const params = {
        title,
        subtitle: this.form.subtitle.trim(),
        summary,
        content,
        categoryIds: this.form.categoryIds,  // 频道 ID 数组
        source: this.getSourceString()       // 数据来源
      }
      if (this.editId) {
        params.id = this.editId
      }
      const submitAudit = this.userType === 'company' ? submitCompanyAudit : submitMemberAudit
      this.submitting = true
      try {
        await submitAudit(params)
        Toast.success('文章提交成功')
        this.$router.replace({ name: 'mobile-articles', params: { tab: 'pending' } })
      } catch (err) {
        Toast(err.message || '文章提交失败')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.m-publish {
  min-height: 100vh;
  background: #F5F7FA;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  padding-bottom: 100px;
}

.m-publish__body {
  margin: 12px;
  background: #fff;
  border-radius: 12px;
  padding: 4px 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

/* ========== 频道选择 ========== */
.m-publish__section {
  padding-bottom: 16px;
}

.m-publish__label {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  margin-bottom: 12px;
}

.m-publish__channel-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-height: 180px;
  overflow-y: auto;
  padding: 4px;
}

.m-publish__channel-tag {
  display: inline-block;
  padding: 6px 16px;
  font-size: 13px;
  color: rgba(51, 51, 51, 1);
  background: rgba(245, 247, 250, 1);
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
}

.m-publish__channel-tag:hover {
  background: rgba(35, 180, 220, 0.1);
  border-color: #23B4DC;
  color: #23B4DC;
}

.m-publish__channel-tag--selected {
  background: #23B4DC;
  border-color: #23B4DC;
  color: #FFFFFF !important;
  font-weight: 500;
  /* 解决移动端字体模糊 */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  /* 添加文字阴影增强清晰度 */
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transform: translateZ(0);
}

.m-publish__channel-tag--selected:hover {
  background: #1CA3C9;
  border-color: #1CA3C9;
}

/* ========== 数据来源 ========== */
.m-publish__radio-group {
  display: flex;
  gap: 28px;
  margin-bottom: 8px;
}

.m-publish__radio-item {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: 13px;
  color: rgba(51, 51, 51, 1);
}

.m-publish__radio-item input[type="radio"] {
  width: 16px;
  height: 16px;
  margin-right: 6px;
  cursor: pointer;
  accent-color: #23B4DC;
  flex-shrink: 0;
}

.m-publish__original-source {
  margin-top: 12px;
}

.m-publish__original-source .m-publish__field {
  padding-left: 0;
}

/* 标题行 */
.m-publish__field {
  display: flex;
  align-items: center;
  gap: 8px;
}

.m-publish__title-input {
  flex: 1;
  padding: 16px 0 12px;
}

.m-publish__title-input /deep/ .van-field__control {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.m-publish__check-btn {
  flex-shrink: 0;
}

/* 副标题 */
.m-publish__subtitle-input {
  padding: 4px 0 12px;
}

.m-publish__subtitle-input /deep/ .van-field__control {
  font-size: 14px;
  color: #666;
}

/* 摘要 */
.m-publish__summary {
  position: relative;
  padding-bottom: 8px;
}

.m-publish__summary-input {
  padding: 4px 0;
}

.m-publish__summary-count {
  text-align: right;
  font-size: 12px;
  color: #bbb;
  padding-right: 4px;
}

.m-publish__divider {
  margin: 4px 0 8px;
}

/* 正文 */
.m-publish__content {
  padding-bottom: 12px;
}

/* 底部 */
.m-publish__footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 20px calc(12px + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
  z-index: 10;
}

.m-publish__tip {
  text-align: center;
  font-size: 12px;
  color: #FF9500;
  margin-top: 6px;
}
</style>
